import React from 'react';
import { Bell } from 'lucide-react';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import { api } from '../../services/api';

export const AlertsTab = ({ alerts, fetchData, formatCurrency }) => {
  if (alerts.length === 0) {
    return (
      <div data-testid="alerts-tab">
        <div className="luxury-card p-12 text-center">
          <Bell size={48} className="text-muted-foreground/30 mx-auto mb-4" />
          <h3 className="text-white font-serif text-xl mb-2">No Price Alerts</h3>
          <p className="text-muted-foreground text-sm">Click the bell on any listing to be notified when its price drops.</p>
        </div>
      </div>
    );
  }
  return (
    <div data-testid="alerts-tab">
      <div className="space-y-3">
        {alerts.map(a => (
          <div key={a.id} className="luxury-card p-4 flex items-center justify-between gap-3" data-testid={`alert-${a.id}`}>
            <div className="flex items-center gap-3 min-w-0">
              <Bell size={14} className={a.triggered ? 'text-emerald-400' : 'text-gold'} />
              <div className="min-w-0">
                <p className="text-white text-sm font-medium truncate">{a.asset_name}</p>
                <p className="text-xs text-muted-foreground">
                  Notify at {formatCurrency(a.target_price)} or below · was {formatCurrency(a.current_price_at_creation)}
                  {a.triggered && a.triggered_price ? ` · Triggered at ${formatCurrency(a.triggered_price)}` : ''}
                </p>
              </div>
            </div>
            <Button size="sm" variant="outline" className="border-red-500/30 text-red-400 text-xs" data-testid={`remove-alert-${a.id}`} onClick={async () => {
              try { await api.deleteFractionAlert(a.id); toast.success('Alert removed.'); fetchData(); }
              catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
            }}>Remove</Button>
          </div>
        ))}
      </div>
    </div>
  );
};
